<script setup lang="ts">
import type { LinkNavTab } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationLinkTabs } from '@shared/ui/menus'

defineOptions({
  name: 'TutorKanbanMenu',
})

const route = useRoute()

const config: LinkNavTab[] = [
  {
    text: 'Onboarding',
    to: AppRoute.TutorKanbanOnboarding,
    selected: route.path === AppRoute.TutorKanbanOnboarding,
    disabled: false,
    visible: true,
  },
  {
    text: 'Probation',
    to: AppRoute.TutorKanbanProbation,
    selected: route.path === AppRoute.TutorKanbanProbation,
    disabled: false,
    visible: true,
  },
  {
    text: 'Active',
    to: AppRoute.TutorKanbanActive,
    selected: route.path === AppRoute.TutorKanbanActive,
    disabled: false,
    visible: true,
  },
]
</script>

<template>
  <NavigationLinkTabs :config="config" />
</template>
